import * as F07_03P1 from "./07_03/Page1";

const Pages = {
    '07_03': {
        1: ['/facsimile/nuernberg/07_03_Correspondenzblatt/nuernberg_bild_0014.jpg', F07_03P1],
    },
};

export {Pages};
